<template>
    <div>
        <div class="tabs pt-8">
            <button v-for="(tab, index) in tabs" :key="index" class="px-6 py-2" :class=" { active: selectedIndex === index }"
                @click="selectTab(index)">
                {{ tab.name }}
            </button>
        </div>
        <div class="tab-content">
            <component :is="selectedComponent"></component>
        </div>
    </div>
</template>
  
  <script>
 import ShippingOptions from './modules/ShippingServiceOptions.vue';
 import FulfilmentOptions from './modules/FulfilmentOptions.vue';
 import ShippingRates from './modules/ShippingRates.vue';
 import ShippingLocations from './modules/ShippingLocations.vue';
 import Returns from './modules/Returns.vue';

  export default {
    components: {
        ShippingOptions,
        FulfilmentOptions,
        ShippingRates,
        ShippingLocations,
        Returns
    },
    data() {
        return {
            selectedIndex: 0,
            tabs: [
                { name: 'Shipping Service Options', component: ShippingOptions },
                { name: 'Fulfillment Options', component: FulfilmentOptions },
                { name: 'Shipping Rates', component: ShippingRates },
                { name: 'Shipping Locations', component: ShippingLocations },
                { name: 'Returns', component: Returns },
            ],
        };
    },

    computed: {
        selectedComponent() {
            return this.tabs[this.selectedIndex].component;
        },
    },

    methods: {
        selectTab(index) {
            this.selectedIndex = index;
        },
    },

  };
  </script>
  
  <style>
  .tabs {
    display: flex;
    cursor: pointer;
    justify-content: center;
  }
  .tabs button {
    font-weight: 600;
    background: rgba(123, 133, 143, 1);
    outline: none;
    cursor: pointer;
    border: transparent;
    border-radius: 1px;
    box-shadow: 0px 0px 20px 2px #00000014;
  }
  .tabs .active {
    font-weight: bold;
    /* border-bottom: 2px solid blue; */
    color: #FCC210;
    background: white;
  }
  
  .tab-content {
    margin-top: 20px;
  }
  </style>